const EMAIL_LOGS_KEY = 'emailLogs';
export const getEmailLogsKey = (args) => args ? [EMAIL_LOGS_KEY, args] : [EMAIL_LOGS_KEY];
//# sourceMappingURL=email.keys.js.map